import React from 'react';
import PropTypes from 'prop-types';

import AdminPagination from '../Pagination';
import AdminResultsPerPageSelector from '../ResultsPerPageSelector';

const AdminRolesFooter = ({
  rolesTotal,
  page,
  perPage,
  handleChangePage,
  handleChangePerPage,
}) => (
  <div className="table-footer">
    <AdminResultsPerPageSelector
      perPage={perPage}
      handleChangePerPage={handleChangePerPage}
    />
    <AdminPagination
      total={rolesTotal}
      page={page}
      perPage={perPage}
      handleChangePage={handleChangePage}
    />
  </div>
);
AdminRolesFooter.propTypes = {
  rolesTotal: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  handleChangePage: PropTypes.func.isRequired,
  handleChangePerPage: PropTypes.func.isRequired,
};

export default AdminRolesFooter;
